import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { marketplaceHomeNavigatedTopic } from '@agilelab/plugin-wb-events-common';
import {
  MainPageType,
  useLastVisitedMainPage,
  useSearchParamChangeObserver,
  useSessionQueryString,
  WbEnvironmentAccessState,
  WbHeader,
} from '@agilelab/plugin-wb-platform';
import { Content } from '@mainstage/core-components';
import { useRouteRef } from '@mainstage/core-plugin-api';
import { makeStyles } from '@material-ui/core';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { marketplaceSearchRef } from '../../routes';
import { SearchPageContent } from './components/SearchPageContent';
import { WbPage } from '@agilelab/plugin-wb-platform';

const useStyles = makeStyles(
  () => ({
    content: {
      minHeight: 0,
    },
  }),
  { name: 'SearchPage' },
);

export const SearchPage = () => {
  const classes = useStyles();
  const [_, setLastVisitedMainPage] = useLastVisitedMainPage(
    MainPageType.MARKETPLACE,
  );

  const searchResultsRoute = useRouteRef(marketplaceSearchRef);
  setLastVisitedMainPage(searchResultsRoute());

  const { publish } = usePublishEvent({ generatorSystem: 'marketplace' });
  const location = useLocation();

  useEffect(() => {
    publish(marketplaceHomeNavigatedTopic, { path: location.pathname });
  }, [publish, location.pathname]);

  const [_sessionQueryString, setSessionQueryString] = useSessionQueryString();
  useSearchParamChangeObserver(
    (_previousSearch: string, currentSearch: string) => {
      setSessionQueryString(currentSearch);
    },
  );

  return (
    <WbPage themeId="home">
      <WbHeader title="Search" hidden />
      <WbEnvironmentAccessState>
        <Content className={classes.content}>
          <SearchPageContent />
        </Content>
      </WbEnvironmentAccessState>
    </WbPage>
  );
};
